function formatSecondsToMinutes(secondsString) {
    // Extract the numeric part of the string
    const seconds = parseInt(secondsString.replace('s', ''), 10);
  
    // Calculate minutes and remaining seconds
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
  
    // Return the formatted result as MM:SS
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
  }

export { formatSecondsToMinutes };